import { useEffect, useState, useContext } from "react";
import { RapMyDNVModal } from "./rap-modal";
import { MyDNVContext } from "mydnv/context/mydnv-context";
import { useNavigate } from "react-router-dom";


const MyDNVRapButton = (props) => {
    const RAPGuestURL = props.configuration.RAPGuestURL;
    const RAPMyDnvURL = props.configuration.RAPMyDnvURL;
    const navigate = useNavigate();

    const [isRapModalOpen, setIsRapModalOpen] = useState(false);

    const {
        account,
        emailVerified,
        isAuthenticated,
        instance,
        inProgress,
        InteractionStatusNone,
    } = useContext(MyDNVContext);


    const handleModal = (isOpen) => {
        setIsRapModalOpen(isOpen);

        if (!isOpen) {
            localStorage.removeItem("signin-redirect-action");
        }
    };

    useEffect(() => {
            // on page load, if user is being redirected from B2C login page
            if (isAuthenticated && inProgress === InteractionStatusNone && emailVerified && !!account) {
                if (localStorage.getItem("signin-redirect-action") === "RAP") {
                    navigate(RAPMyDnvURL);
                }
            }
        }, [
            account,
            emailVerified,
            instance,
            isAuthenticated,
            inProgress,
            InteractionStatusNone
        ]);

    return (
        <>
            <button 
                className="btn rap-btn"
                onClick={() => setIsRapModalOpen(true)}
            >
                Report a Problem
            </button>

            <RapMyDNVModal 
                isOpen={isRapModalOpen}
                setModalOpen={handleModal}
                RAPGuestURL={RAPGuestURL}
                RAPMyDnvURL={RAPMyDnvURL}
            />
        </>
    );
}

export { MyDNVRapButton };